import './admin-profile-courses.scss';
import {useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import AdminCourseCard from "./AdminCourseCard";

interface ProfileCoursesProps {
  programId: number,
  courses: any
}

const ProfileCourses = (props: ProfileCoursesProps) => {
  const {
    programId,
    courses
  } = props;

  const navigate = useNavigate();
  const {user_id, portfolio_id} = useParams();
  const [showAllCourses, setShowAllCourses] = useState<boolean>(false);


  return <div className={'admin-profile-courses'}>
    {courses &&
      courses.map((item: any) =>
        <AdminCourseCard
          title={item.course_title}
          buttonText={'Review this course'}
          code={item.course_code}
          cplEligible={item.course_cpl_eligible}
          assignedTo={item.course_recommendation_assigned_to}
          isPaid={item.purchased}
          matchingScore={`${item.recommendation_score * 100}% match`}
          onClick={() => navigate(`/cpl-admin/${user_id}/${portfolio_id}/${programId}/${item.course_code}`)}
          approved={item.approved}
        />
      )}

    {!showAllCourses
      ? <div className={'admin-profile-courses-see-all'}
             onClick={() => navigate(`/cpl-admin/${user_id}/${portfolio_id}/${programId}`)}>
        See all recommended courses
      </div>
      : null
    }

  </div>
}

export default ProfileCourses;